module.exports = __webpack_public_path__ + "img/mobile.6b7e3497.png";